import { dataMiniAppBaiduSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMiniAppBaiduSolid = /*#__PURE__*/createIcon(dataMiniAppBaiduSolid)
export default IconMiniAppBaiduSolid
